import React, { useState, useEffect, useCallback } from 'react'
import { Select } from '../../../ui-kit'
import { ApiCodeListsRepository } from '../../../api/ApiCodeListsRepository'
import { i18n } from '../../../utils/intl'

type Option = {
  text: string
  value: string
}

export interface TransactionTypesFilterProps {
  onTransactionTypeChange?: (id?: string) => void
}

export const TransactionTypesFilter = (props: TransactionTypesFilterProps) => {
  const [transactionType, setTransactionType] = useState('')
  const [options, setOptions] = useState([] as Option[])

  const onTransactionTypeChange = useCallback(
    (arg: string) => {
      setTransactionType(arg)
      // eslint-disable-next-line no-unused-expressions
      props.onTransactionTypeChange && props.onTransactionTypeChange(arg === '' ? undefined : arg)
    },
    [setTransactionType, props]
  )

  useEffect(() => {
    ApiCodeListsRepository.fetchTransactionTypes().then(data => {
      setOptions([
        {
          text: i18n.t`Všetky transakcie`,
          value: '',
        },
        ...data.data!.map(i => {
          return {
            text: i.name,
            value: String(i.id),
          }
        }),
      ])
    })
  }, [])

  return (
    <Select
      transparent
      size="small"
      value={transactionType}
      id="filter-transaction"
      onChange={onTransactionTypeChange}
      options={options}
      dropdownStyles={{ minWidth: 175 }}
    />
  )
}
